import BrandMark from './logo2.svg';

export default function Brand() {
  return (
    <span className="brand-lockup" aria-label="driverOS">
      <img src={BrandMark} alt="" aria-hidden="true" />
      <span>driverOS</span>
    </span>
  );
}
